module.exports = __webpack_public_path__ + "media/images/pic/hero/sun-5d09d08803f59f1c1a75e52c690d7fa2.png";